import { render, staticRenderFns } from "./reject-request.vue?vue&type=template&id=5f74e44c&scoped=true&"
import script from "./reject-request.vue?vue&type=script&lang=js&"
export * from "./reject-request.vue?vue&type=script&lang=js&"
import style0 from "./reject-request.vue?vue&type=style&index=0&id=5f74e44c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f74e44c",
  null
  
)

export default component.exports